<template>
  <el-row :gutter="5">
    <el-col :span="9">
      <el-card shadow="never">
        <div slot="header">
          <span>组织机构</span>
        </div>
        <org @current-change="setOrg" style="height: calc( 100vh - 210px);overflow: auto;"></org>
      </el-card>
    </el-col>
    <el-col :span="15">
      <el-card shadow="never" style="height: calc( 100vh - 134px);overflow: auto;">
        <div slot="header">
          <span>人员</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ currentOrg.name }}({{ rows.length }})</span>
          <el-button v-show="showSaveBtn" style="float: right; padding: 3px 0" type="text"
                     @click="removeVisible = !removeVisible">
            移动到
          </el-button>
        </div>
        <el-table v-loading="searching" :data="rows" border @selection-change="selectionChangeHandler">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column label="用户名" prop="username" sortable></el-table-column>
          <el-table-column label="姓名" prop="name" sortable></el-table-column>
          <el-table-column label="组织机构" prop="orgNames" sortable></el-table-column>
          <el-table-column label="角色" prop="roleName" sortable></el-table-column>
        </el-table>
      </el-card>
    </el-col>
    <el-dialog :visible.sync="removeVisible">
      <el-form>
        <el-form-item>
          <org-cascader-panel v-model="orgCodes"></org-cascader-panel>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitRemove">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
  import Org from "./Org";
  import BasePage from "@/components/BasePage"
  import {userList, userUpdate} from "@/api/remote";
  import OrgCascaderPanel from "./OrgCascaderPanel";

  export default {
    name: "OrgMembers",
    components: {OrgCascaderPanel, Org},
    mixins: [BasePage],
    data() {
      return {
        currentOrg: {
          name: null,
          code: '',
          type: null,
        },
        rows: [],
        initRows: false,
        showSaveBtn: false,
        selection: [],
        removeVisible: false,
        orgCodes: [],
      }
    },
    methods: {
      selectionChangeHandler(selection) {
        this.selection = selection;
        this.showSaveBtn = true;
      },
      submitRemove() {
        if (this.orgCodes.length < 1) {
          this.$message.warning('请选择组织机构');
          return
        }
        let orgCode = this.orgCodes[this.orgCodes.length - 1];
        let size = this.selection.length;
        this.selection.forEach(item => {
          item.orgCode = orgCode;
          userUpdate(item).then(res => {
            size--;
            if (size < 1) {
              this.removeVisible = false;
              this.getRows(this.currentOrg);
            }
            this.$message.success(`${item.username}修改成功`);
          })
        })
      },
      getRoleByCode(code) {
        return this.$store.getters.getRoleByCode(code);
      },
      setOrg(org) {
        if (!org) {
          org = {name: null, code: '', type: null,}
        }
        this.currentOrg = org;
        this.getRows(org);
        this.showSaveBtn = false;
      },
      getRows(org) {
        this.searching = true;
        let form = {orgCode: org.code, orgCodeLike: 1};
        // form[org.type + 'Code'] = org.code;
        userList(form).then(res => {
          this.rows = res.data;
          this.searching = false;
        }, () => this.searching = false)
      },
    },
    created() {
      this.$store.commit('initRoles');
      this.getRows(this.currentOrg);
    },
  }
</script>

<style scoped>

</style>
